import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

import { ValidationStatusResponse } from '../models/validation-status.model';

/**
 * Consulta el estado de validación del usuario invitado:
 *  - `quizStatus`: si ya completó el cuestionario.
 *  - `backofficeStatus`: si backoffice ya revisó/aprobó al usuario.
 *  - `fullyValidated`: bandera consolidada para saber si ya puede operar.
 */
@Injectable({ providedIn: 'root' })
export class UserValidationService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.baseUrl}user/validation-status`;

  getValidationStatus(): Observable<ValidationStatusResponse> {
    return this.http.get<ValidationStatusResponse>(this.url);
  }
}
